import type { IconType } from "react-icons";
import { FiFileText, FiList, FiPlus, FiSearch, FiZap } from "react-icons/fi";
import type { AppRole } from "../../../common/layout/v2/navConfig";
import { urls } from "../../../urls";

export type HeroActionTarget = { kind: "navigate"; to: string } | { kind: "action"; action: "createSourcingEvent" | "createNeed" };
export type HeroMetric = "reportedNeeds" | "activeContracts";
export type PanelKind = "activeProcurements" | "latestDrafts" | "myNeeds" | "activeContracts" | "myBids" | "openProcurements";

export interface HeroAction {
  key: string;
  labelKey: string;
  sublabelKey: string;        // static fallback text; metric overrides it when set
  icon: IconType;
  variant: "primary" | "default";
  target: HeroActionTarget;
  metric?: HeroMetric;
}
export interface HomeConfig { headlineKey: string; heroActions: HeroAction[]; panels: PanelKind[]; }

export const homeConfig: Record<AppRole, HomeConfig> = {
  advisor: {
    headlineKey: "What will you work on today?",
    heroActions: [
      { key: "start", labelKey: "Start procurement", sublabelKey: "Create and announce", icon: FiPlus, variant: "primary", target: { kind: "action", action: "createSourcingEvent" } },
      { key: "assess", labelKey: "Assess need", sublabelKey: "Review reported needs", icon: FiZap, variant: "default", target: { kind: "navigate", to: `${urls.v2.needs.list}?status=REPORTED` }, metric: "reportedNeeds" },
      { key: "agreements", labelKey: "Active agreements", sublabelKey: "Your live contracts", icon: FiFileText, variant: "default", target: { kind: "navigate", to: urls.v2.contracts.active }, metric: "activeContracts" },
    ],
    panels: ["activeProcurements", "latestDrafts"],
  },
  orderer: {
    headlineKey: "What are you looking for?",
    heroActions: [
      { key: "report", labelKey: "Report need", sublabelKey: "Register a new need", icon: FiPlus, variant: "primary", target: { kind: "action", action: "createNeed" } },
      { key: "mine", labelKey: "My needs", sublabelKey: "Your registered needs", icon: FiList, variant: "default", target: { kind: "navigate", to: urls.v2.needs.mine } },
      { key: "agreements", labelKey: "Active agreements", sublabelKey: "Your live contracts", icon: FiFileText, variant: "default", target: { kind: "navigate", to: urls.v2.contracts.active }, metric: "activeContracts" },
    ],
    panels: ["myNeeds", "activeContracts"],
  },
  supplier: {
    headlineKey: "Find your next opportunity",
    heroActions: [
      { key: "browse", labelKey: "Find procurements", sublabelKey: "Browse published competitions", icon: FiSearch, variant: "primary", target: { kind: "navigate", to: urls.v2.supplier.procurements } },
      { key: "bids", labelKey: "My bids", sublabelKey: "Your offers in progress", icon: FiFileText, variant: "default", target: { kind: "navigate", to: urls.v2.supplier.bids } },
      { key: "requests", labelKey: "My requests", sublabelKey: "Your participation requests", icon: FiList, variant: "default", target: { kind: "navigate", to: urls.v2.supplier.requests } },
    ],
    panels: ["myBids", "openProcurements"],
  },
};
